import React from "react";
import "../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import ProfileManagementForm from "./ProfileManagementForm";

const CallEditProfileManagement = ({ match }) => {

    return (
        <div>
            <DashboardNavBar />
            <SideBar />
            <ProfileManagementForm  profileId={match.params.id} context={"edit"} />
        </div>
    );
}

export default CallEditProfileManagement;